import React from 'react';

const Header = () => {
    // the header for the app

    return (
        <div className='header container flex-column edge-container header-container'>
            <h1
                className='text header-link'
                onClick={() => window.location.href = '/stories'}
            >
                Peril & Intrigue
            </h1>
        </div>
    );
};

export default Header;
